import * as React from 'react'
import { useImmer } from 'use-immer'
import { Button, Tooltip } from 'antd'
import { set } from 'lodash'
import { t } from 'helpers/i18n'
import Icon from 'elements/Icon'
import Modal from 'elements/Modal'
import SelectProduct from 'containers/Products/Select'

function Component(props) {
  const [state, updateState] = useImmer({})
  const { visible, item } = state

  const setState = React.useCallback((name, value) => {
    updateState((draft) => {
      set(draft, name, value)
    })
  }, [])

  function handleModalOk() {
    props.onSelect?.(item)

    setState('visible', false)
  }

  React.useEffect(() => {
    setState('item', null)
  }, [visible])

  return (
    <>
      <Tooltip title={t('selectProduct')} placement="topLeft">
        <Button
          type="primary"
          size="small"
          onClick={() => setState('visible', true)}
          disabled={props.readOnly || props.disabled}
        >
          <Icon type="Add" bold />
        </Button>
      </Tooltip>
      <Modal
        title={t('selectProduct')}
        visible={visible}
        okText={t('select')}
        onOk={handleModalOk}
        okButtonProps={{ disabled: !item }}
        onCancel={() => setState('visible', false)}
        width={992}
      >
        <SelectProduct onSelect={(values) => setState('item', values[0])} />
      </Modal>
    </>
  )
}

export default Component
